<template>
  <DBox
    :id="'dbox-invoice-royalty-rates'"
    :addButton="false"
    :rightMenu="[
      {
        text: $t('perform'),
        value: 'perform',
      },
    ]"
    @menuClick="onMenuClick"
  >
    <DatePicker2
      lw="135px"
      id="royalty_date1"
      :disabled="selectedInvoice.disabled"
      :label="$dft.capHead($t('adjust_sales_period'))"
      :value="selectedInvoice.invoice.royalty_date1"
      @input="onRolatyDateUpdate"
    />
    <DatePicker2
      lw="135px"
      :disabled="selectedInvoice.disabled"
      id="royalty_date2"
      :label="$dft.capHead($t('adjust_payment_period'))"
      :value="selectedInvoice.invoice.royalty_date2"
      @input="onRolatyDateUpdate"
    />
    <!--
      <div class="form-group" v-if="selectedInvoice">
      <DatePicker
        id="royalty_date1"
        :disabled="selectedInvoice.disabled"
        :placeholder="$t('adjust_sales_period')"
        :value="selectedInvoice.invoice.royalty_date1"
        @valuechanged="onRolatyDateUpdate"
      />
      <DatePicker
        :disabled="selectedInvoice.disabled"
        id="royalty_date2"
        :placeholder="$t('adjust_payment_period')"
        :value="selectedInvoice.invoice.royalty_date2"
        @valuechanged="onRolatyDateUpdate"
      />
    </div>      
    -->
    <!-- <button class="dt-button s1 v1" @click="onPerformClick">Perform</button> -->
  </DBox>
</template>

<script>
import { EventHooks } from "../../../../plugins/text-field";
import { createCountriesTV } from "../../../../models/country.model";
import { createLanguageTV } from "../../../../models/language.model";
import { tv } from "../../../../models/text-value.model";
import { createUserTV } from "../../../../models/user.model";
import DatePicker from "@plugins/text-field/date-picker";
import { createCurrencyTV } from "../../../../models/currency.model";
import { InvoicesService } from "../../services/invoices.service";
import { showNotification } from '../../../../dt-plugins/notification/notification.service';

export default {
  components: {
    DatePicker,
  },
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    };
  },
  methods: {
    onRolatyDateUpdate: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    onPerformClick: async function () {
      const res = await InvoicesService.performRoyaltyDates({
        invoice_id: this.selectedInvoice.invoice.invoice_id,
      });

      console.log(res,"::::::::::");
      const statements = res.data.statements;

      if(statements && statements.length>0){
          this.$emit('perform_click',statements)
      }else{
        //update_royalty_date_response
        showNotification(this.$t('perform_confirmation'));
      }

      
    },

    onMenuClick(value) {
      if (value === "perform") {
        this.onPerformClick();
      }
    },
  },
};
</script>

<style lang="scss">
</style>
